<div
  id="idMenuArbolWrapper"
  *ngIf="!answerDisplayed && !cargandoDatos"
  style="height: 100%"
>
  <div
    id="idMenuArbolInnerContent"
    class="card-body bg-white menu-inner-content"
    style="border-radius: 4px 4px 0px 0px"
  >
    <app-enlace-back
      *ngIf="this.currentFather && this.currentFather.id !== 'ROOT'"
      (click)="loadParent()"
      [enlace_texto]="
        this.currentGrandparent
          ? !(this.currentGrandparent.name === ' Raiz')
            ? 'Volver
    a ' + this.currentGrandparent.name
            : ' Elegir otro tema de consulta'
          : 'Elegir otro tema de consulta'
      "
    ></app-enlace-back>
    <app-enlace-back
      *ngIf="this.displayCurrentFatherOldMenu"
      (click)="loadParentOldMenu()"
      [enlace_texto]="
        this.temaCurrentFatherOldMenu
          ? 'Volver a ' + this.temaCurrentFatherOldMenu
          : 'Elegir otro tema de consulta'
      "
    ></app-enlace-back>
    <div class="card-body-content" *ngIf="habilitado">
      <div
        id="divNodoPadreSelected"
        [attr.data-valor]="miValorVariablePadre"
        *ngIf="mostrarDiv"
      ></div>
      <div
        id="divNodoSelected"
        [attr.data-valor]="miValorVariable"
        *ngIf="mostrarDiv"
      ></div>

      <app-titulo-h1
        [titulo]="
          this.currentFather && this.currentFather.name !== 'Raiz'
            ? this.currentFather.name
            : '¿Cómo puedo ayudarte?'
        "
      ></app-titulo-h1>
      <h5 *ngIf="currentFAQ.length > 0" class="font-weight-normal f-18">
        {{
          this.currentFather.name !== "Raiz"
            ? "Lo más
        consultado"
            : "Están consultando hoy..."
        }}
      </h5>
      <ul class="list-pretty pl-4 mt-3">
        <li *ngFor="let faqNode of currentFAQ">
          <app-nodo-arbol
            [node]="faqNode"
            (displayAnswerEmitter)="displayAnswer($event)"
          ></app-nodo-arbol>
        </li>
      </ul>
      <div class="listado_con_tituloh2">
        <app-titulo-h2
          [titulo]="
            this.currentFather && this.currentFather.name !== 'Raiz'
              ? null
              : 'Elegir un tema para
        consultar:'
          "
        ></app-titulo-h2>
        <h5
          *ngIf="
            this.currentFather &&
            this.currentFather.name !== 'Raiz' &&
            currentFAQ.length > 0
          "
          class="font-weight-bold f-18"
        >
          {{ "Elegí una opción" }}
        </h5>

        <div class="css-Listado_Items listado_items">
          <app-nodo-arbol
            *ngFor="let node of displayedNodes"
            [ctx]="ctx"
            [node]="node"
            [cantidadNodos]="cantidadNodos"
            [numberOfSiblingsArr]="numberOfSiblingsArr"
            [numberOfSiblingsArrCreation]="numberOfSiblingsArrCreation"
            (displayAnswerEmitter)="displayAnswer($event)"
            (nodeEmitter)="seleccionarNodo($event)"
            (renderMenuArbolEmitter)="emitRenderMenuArbol($event)"
          >
          </app-nodo-arbol>
        </div>
      </div>

      <br />
    </div>
    <div class="card-body-content" *ngIf="!habilitado">
      <h4 class="titulo-principal mt-2 mb-4 f-22">
        No es posible visualizar el contenido del presente menú ya que se
        encuentra deshabilitado.
      </h4>
      <br />
    </div>
  </div>

  <!-- seccion blanca placeholder que se despliega en lugar del link al formulario-->
  <div
    id="id_footer-placeholder"
    *ngIf="this.currentFather && this.currentFather.name === 'Raiz'"
    class="card-body bg-white place-holder-box"
  ></div>

  <div
    id="id_goto_form"
    *ngIf="
      this.currentFather &&
      this.currentFather.name !== 'Raiz' &&
      this.displayFormEmpresa &&
      this.displayForm
    "
    class="card-body bg-white"
    style="
      height: 40px;
      font-family: 'Roboto', sans-serif;
      border-radius: 0px 0px 4px 4px;
    "
  ></div>
  <div
    id="footer"
    class="card-footer border-0 text-center"
    (click)="irToStartNode()"
    *ngIf="
      displayButtonReturnNode &&
      this.currentFather &&
      this.currentFather.id != this.ctx.idNodo
    "
  >
    <a class="text-white f-13">Volver al inicio</a>
  </div>
</div>

<div *ngIf="answerDisplayed">
  <div
    class="card-body bg-white response-box"
    style="border-radius: 4px 4px 0px 0px"
  >
    <app-enlace-back
      (click)="clearAnswerDisplayedNode()"
      [enlace_texto]="obtenerEtiquetaVolver()"
    ></app-enlace-back>
    <div
      id="divNodoPadreSelected"
      [attr.data-valor]="miValorVariablePadre"
      *ngIf="mostrarDiv"
    ></div>
    <div
      id="divNodoSelected"
      [attr.data-valor]="miValorVariable"
      *ngIf="mostrarDiv"
    ></div>
    <div class="card-body-content-response">
      <h4 class="titulo-principal mt-2 mb-4 f-22">{{ answerNode.name }}</h4>
      <div [innerHtml]="answerNode.answer"></div>
    </div>
  </div>
</div>

<div class="spinner-overlay" *ngIf="cargandoDatos">
  <div class="spinner-center">
    <mat-spinner diameter="80" color="primary"></mat-spinner>
    <label class="input-label" *ngIf="cargandoDatos"
      >&nbsp; Cargando datos...</label
    >
  </div>
</div>
